<section class="takePhoto getSkinAnalysis pos-rel flex-col m16 bdr-rad-20 pB20 rebranded-diet-banner" id="takePhoto" *ngIf="userStatus.PAID && showGameBanner" (click)="handleClick()">
  <div class="game-img tw-bg-green-200 bdr-rad-20 tw-mb-4 tw-overflow-hidden">
    <img class="tw-bg-[#76539a] tw-w-full tw-h-auto" src="https://cdn.cureskin.com/article_image/1686717465_e71180c96f27476bbadc5e71178432c0.gif" />
  </div>
  <div class="fw-700 font20 mL16 " i18n="@@answerOneQuestionADay">Answer one question a day!</div>
  <div class="tw-flex tw-items-end">
    <div class="tw-flex-1 tw-flex tw-flex-col tw-self-center">
      <div class="mL16 tw-mr-3" i18n="@@boostYourKnowledgeAndGetChanceToWinCureskinCash">
        Boost your knowledge and get a chance to win Cureskin cash for correct answers.
      </div>
    </div>
    <div
      class="tw-bg-teal-600 tw-flex tw-items-center tw-justify-center tw-rounded-2 tw-h-8 tw-px-4 tw-mr-4 tw-text-white"
      role="button"
    >
      <span class="tw-font-body tw-tracking-normal tw-capitalize tw-text-200 tw-font-semibold tw-text-white" i18n="@@playQuiz">Play Quiz</span><cs-icon class="tw-h-4 tw-w-4 tw-text-white" [iconName]="'chevron_right'"></cs-icon>
    </div>
  </div>
</section>
